import React, { useState, useRef, useEffect, useMemo, useCallback} from 'react';

import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';

import 'ag-grid-enterprise/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-enterprise/styles/ag-theme-alpine.min.css'; // Optional theme CSS

import ButtonDeviceInfoRenderer from './ButtonDeviceInfoRenderer';

import { useUser } from '../hooks/UserContext';

const DevicesPage = () => {

 const gridRef = useRef(); // Optional - for accessing Grid's API
 const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
 const { user } = useUser();
 
 let isUserAdmin = 0
 try {
  const u = user ? (typeof user === 'string' ? JSON.parse(user) : user) : {};
  if (u.isAdmin !== undefined) isUserAdmin = u.isAdmin;
 } catch(e) {}

 // Each Column Definition results in one Column.
 const [columnDefs] = useState([
        { field: 'Action', cellRenderer: ButtonDeviceInfoRenderer, hide: isUserAdmin !== 1},
        {field: 'name'},
        {field: 'wfmc'},
        {field: 'site'},
        {field: 'position'},
        {field: 'status'},
        {field: 'param_1'},
        {field: 'param_2'},
        {field: 'param_3'},
        {field: 'last_read.dt', width: 250,},
        {field: 'last_read.type'},
        {field: 'last_read.val'},
        {field: 'last_read.units'},
        {field: 'last_read.org'},
        {field: 'last_read.ver'},
        {field: 'last_read.local_ip'},
        {field: 'last_read.rwmc'},        
        {field: 'location.lat'},
        {field: 'location.lon'},
        {field: 'frq_m'},
        {field: 'dt', width: 250, headerName: 'Last Modified',/* valueGetter: dateValueGetter, */ },
 ]);
 

 // DefaultColDef sets props common to all Columns
 const defaultColDef = useMemo( ()=> ({
    // flex: 1,
     sortable: true, 
     filter: 'agTextColumnFilter',
     enableRowGroup: true,
     menuTabs : ['filterMenuTab', 'generalMenuTab'],
     floatingFilter: true,
   }));

   

   const statusBarDefs = {
    statusPanels: [
      {
        statusPanel: 'agTotalAndFilteredRowCountComponent',
        align: 'left',
      },
      {
        statusPanel: 'agTotalRowCountComponent',
        align: 'center',
      },
      { statusPanel: 'agFilteredRowCountComponent' },
      { statusPanel: 'agSelectedRowCountComponent' },
      // { statusPanel: 'agAggregationComponent' },
    ],
  }
  
  function isRefreshEnabledSelected() {
    return document.querySelector('#refreshEnabled').checked;
  }

 // Example of consuming Grid Event
 const cellClickedListener = useCallback( event => {
   console.log('cellClicked', event);
 }, []);

 const firstDataRendered = useCallback( event => {
   console.log('firstDataRendered', event);
 }, []);

 const refreshGridData = () => {
  if(isRefreshEnabledSelected()){ 
    fetch(`${window.location.origin}/devices?action=all`)
      .then(response => response.json())
      .then(data => setRowData(data))
      .catch(error => console.error(error));
  }
};
 // load data from sever
 useEffect(() => {
      refreshGridData(); // Initial load
      const intervalId = setInterval(refreshGridData, 5 * 1000);
      return () => clearInterval(intervalId);
 }, []);

 return (
   <div style={{ height: '100%', width: '100%', }} >

     <label htmlFor="refreshEnabled">
        <input type="checkbox" id="refreshEnabled" defaultChecked />
        Refresh Every 5 Seconds
      </label>

     {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
     <div className="ag-theme-alpine-dark" style={{ height: '100%', width: '100%', }} >
      
     <AgGridReact style={{ height: '100%', width: '100%', }} 
           ref={gridRef} // Ref for accessing Grid's API

           rowData={rowData} // Row Data for Rows

           columnDefs={columnDefs} // Column Defs for Columns
           defaultColDef={defaultColDef} // Default Column Properties

           // animateRows={true} // Optional - set to 'true' to have rows animate when sorted
           rowSelection='multiple' // Options - allows click selection of rows

           onCellClicked={cellClickedListener} // Optional - registering for Grid Event
           onFirstDataRendered={firstDataRendered}
           
           rowGroupPanelShow = 'always'
          
            statusBar = {statusBarDefs}
            pagination = 'true'
            enableCellTextSelection = 'true'
            // rowDragManaged = 'true'
            // enableColumnAutosize = 'true'
            // enableCharts = 'true'
            // enableRangeSelection = 'true'
            animateRows = 'true'
            enableCharts = 'true'
           />
     </div>
   </div>
 );
};

export default DevicesPage;